import { customFetch } from 'utils/http';
import { UnexpectedError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';

export const moveUserToArchive = async (idUser: number) => {
  const body = new FormData();

  body.append('idUser', `${idUser}`);

  const response = await customFetch(getM8AdminURL('moveUserToArchive'), {
    method: 'POST',
    body,
  });

  if (!response.ok) {
    throw new UnexpectedError();
  }
};
